export enum EventPrivacy {
    Public = "PUBLIC",
    InnerCircle = "INNER_CIRCLE",
    InviteOnly = "INVITE_ONLY",
}